import { SEOHead } from "@/components/SEOHead";
import { campgroundSchema, videoObjectSchema } from "@/lib/schema";
import { UNIQUE_AMENITIES, amenityList } from "@/content/amenities";
import { Header } from "@/components/layout/Header";
import { RelatedReads } from "@/components/seo/RelatedReads";
import { getPostsBySlugs } from "@/content/blogPosts";
import { Footer } from "@/components/layout/Footer";
import { SEOContentBlock } from "@/components/seo/SEOContentBlock";
import { Testimonials } from "@/components/seo/Testimonials";
import { seoCopy } from "@/content/seoCopy";
import {
  HeroSection,
  PhotoGallerySection,
  ProblemSection,
  ImageBreakSection,
  HowTheDayFlowsSection,
  DifferentiatorsSection,
  ExperienceOptionsSection,
  ComparisonSection,
  LocationMapSection,
  FinalCTASection,
} from "@/components/home/HomeSections";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="River Cabanas & Tubing in New Braunfels | Son's"
        description="Private riverside cabanas, family tubing & glamping on the Guadalupe River in New Braunfels. Float back to your cabana — not a parking lot. Book today!"
        canonical="/"
        ogImage="/og/home.jpg"
        schemaJson={[
          campgroundSchema({
            "@id": "https://sonsguadalupe.com/#lodging",
            description:
              "Private riverside cabanas, AC-cooled bell tent glamping, and shuttle-assisted tubing on the Guadalupe River in New Braunfels, TX. 22 private cabanas with grills, in-water covered picnic tables, dedicated parking, and direct river access — float ends at your private cabana.",
            image: "https://sonsguadalupe.com/og/home.jpg",
            currenciesAccepted: "USD",
            paymentAccepted: "Credit Card",
            hasMap: "https://www.google.com/maps/place/Son's+Guadalupe",
            openingHoursSpecification: [
              {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday",
                ],
                opens: "09:00",
                closes: "19:00",
              },
            ],
            amenityFeature: amenityList([
              ...UNIQUE_AMENITIES,
              "Free Wi-Fi",
              "Fire pits",
              "Tubing & kayak rentals",
            ]),
            areaServed: [
              { "@type": "City", name: "New Braunfels" },
              { "@type": "City", name: "San Antonio" },
              { "@type": "City", name: "Austin" },
              { "@type": "State", name: "Texas" },
            ],
          }),
          {
            "@context": "https://schema.org",
            "@type": "TouristAttraction",
            name: "Son's Guadalupe",
            description:
              "Private riverside cabanas, tubing, and glamping on the Guadalupe River in New Braunfels, TX.",
            url: "https://sonsguadalupe.com",
            image: "https://sonsguadalupe.com/og/home.jpg",
            telephone: "+1-877-577-7667",
            address: {
              "@type": "PostalAddress",
              streetAddress: "7308 River Road",
              addressLocality: "New Braunfels",
              addressRegion: "TX",
              postalCode: "78132",
              addressCountry: "US",
            },
          },
          videoObjectSchema({
            name: "Son's Guadalupe River Experience",
            description:
              "Aerial and on-the-river footage of Son's Guadalupe — private riverside cabanas, family tubing, glamping, and the spring-fed Guadalupe River near New Braunfels, TX.",
            thumbnailUrl: "https://i.ytimg.com/vi/dXZnZHI68KU/maxresdefault.jpg",
            uploadDate: "2024-06-01",
            embedUrl: "https://www.youtube-nocookie.com/embed/dXZnZHI68KU",
            contentUrl: "https://www.youtube.com/watch?v=dXZnZHI68KU",
          }),
        ]}
      />
      <Header />
      <main>
        <HeroSection />
        <PhotoGallerySection />
        <ExperienceOptionsSection />
        <ProblemSection />
        <ImageBreakSection />
        <HowTheDayFlowsSection />
        <DifferentiatorsSection />
        <Testimonials />
        <ComparisonSection />
        <LocationMapSection />
        <FinalCTASection />
      </main>
      <SEOContentBlock {...seoCopy.index} />
      <RelatedReads posts={getPostsBySlugs(["memorial-day-weekend-guadalupe-river", "tubing-guadalupe-river-new-braunfels", "cabana-rentals-price-whats-included"])} heading="From our blog" />
      <Footer />
    </div>
  );
};

export default Index;
